import { Component, Input } from '@angular/core';

import { ContainerComponent } from '../container/container.component';
import { GlobalButtonComponent } from '../global-button/global-button.component';
import { CommonModule } from '@angular/common';

export interface ctaBottom {
  icon: string;
  alt?: string;
  title: string;
  text?: string;
  button: {
    buttonLabel: string;
    buttonUrl: string;
    openInNewTab: boolean;
    buttonIcon: string;
  };
}

@Component({
  selector: '[cta-bottom]',
  imports:
    [
      CommonModule,
      ContainerComponent,
      GlobalButtonComponent
    ],
  templateUrl: './cta-bottom.component.html',
  styleUrl: './cta-bottom.component.scss',
})
export class CtaBottomComponent {
  @Input() data: ctaBottom = {
    icon: '',
    title: '',
    text: '',
    button: {
      buttonLabel: '',
      buttonUrl: '',
      openInNewTab: false,
      buttonIcon: '',
    },
  };
}
